import axios from 'axios'
import router from '@/router'

/**
 * objeto base para o axios, para configurarmos a url base
 * nos requests posteriores precisamos apenas da restante da url
 * as chamadas estao abstraidas nos resources
 */
const axiosObject = axios.create({
  baseURL: process.env.VUE_APP_BASEPATHAPI,
  // responseType: 'json',
});

/**
 * para todo request, fazemos um replace das variaveis passadas
 * por urlParams e montamos a url final, dessa forma deixamos as
 * urls nos resources mais legiveis e sem a necessidade de montar caso a caso
 * basta colocar na url a chave que passar no parametro
 * exemplo
 *  /chamada/listar/usuario/:id
 * 
 * como parametros da chamada passe um json
 * {
 *   urlParams: {
 *     id: 35
 *   }
 * }
 * e pronto o resto jah estah tratado aqui....
 * 
 * outra acao relizada neste ponto eh adicionar o Authenticaion 'Bearer ' + <TOKEN> se existir...
 */

function cleanObject(obj) {
  for (let propName in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, propName)) {
          if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
              delete obj[propName];
          }
      }
  }
  return obj;
}

axiosObject.interceptors.request.use((config) => {
  if (!config.url) {
    return config;
  }

  if (config.data) config.data = cleanObject(config.data);
  if (config.params) config.params = cleanObject(config.params);


  // --- primeiro os parametros de url
  const currentUrl = new URL(config.url, config.baseURL);

  Object.entries(config.urlParams || {}).forEach(([k,v]) => {
    currentUrl.pathname = currentUrl.pathname.replace(`:${k}`, encodeURIComponent(v));
  });

  const authPart = currentUrl.username && currentUrl.password ? `${currentUrl.username}:${currentUrl.password}` : '';

  // --- depois header extra....
  const token = localStorage.getItem('user-token', null);
  if ( token != null ) {
    config.headers.Authorization = `Bearer ${token}`;
   
  }

  // retorna as novas configs...
  return {
    ...config,
    baseURL: `${currentUrl.protocol}//${authPart}${currentUrl.host}`,
    url: currentUrl.pathname,
  };
});

/***
 * para garantir que qualquer acesso sem autorizacao falhe, temos esse interceptor
 * que verifica se o retorno for 401, manda pro login...
 */
axiosObject.interceptors.response.use(undefined, function (err) {
  return new Promise(function (resolve, reject) {
    if (err.response.status && err.response.status === 401 ) {
      router.push('/system/login')
    }
    throw err;
  });
});

export const axiosInstance = axiosObject